import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

/**
 * Markdown for assistant answers. The text is model-generated and may echo device-written data, so it is
 * sanitised with DOMPurify (and again by Angular's [innerHTML] sanitiser) — never trusted.
 */
@Pipe({ name: 'assistantMarkdown', standalone: true })
export class AssistantMarkdownPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) return '';
        const html = marked.parse(value, { async: false, breaks: true, gfm: true });
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'b', 'i', 'code', 'pre', 'ul', 'ol', 'li', 'a', 'blockquote', 'h3', 'h4', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'hr', 'del'],
            ALLOWED_ATTR: ['href', 'title'],
            ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|\/)/i
        });
    }
}
